import { render, staticRenderFns } from "./SalaryInformation.vue?vue&type=template&id=479affa4&scoped=true&"
import script from "./SalaryInformation.vue?vue&type=script&lang=js&"
export * from "./SalaryInformation.vue?vue&type=script&lang=js&"
import style0 from "./SalaryInformation.vue?vue&type=style&index=0&id=479affa4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479affa4",
  null
  
)

export default component.exports